import React from 'react';
import { Box, Typography } from '@mui/material';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import noVarianceIcon from 'assets/images/mappedicon.svg';
import { formatCurrency } from 'utils';

// Render Variance helper
export const renderVariance = (variance: number | string, isCurrency: boolean = false) => {
    const val = typeof variance === 'string' ? parseFloat(variance) : variance;
    if (isNaN(val) || val === 0) {
        return (
            <>
                <Box className="status-dot" />
                <img src={noVarianceIcon} alt="success" className="status-icon success" />
            </>
        );
    }

    const isPositive = val > 0;
    const Icon = isPositive ? TrendingUpIcon : TrendingDownIcon;
    const statusClass = isPositive ? 'positive' : 'negative';
    const displayVal = isCurrency ? formatCurrency(Math.abs(val)) : Math.abs(val);

    return (
        <>
            <Box className="status-dot" />
            <Icon className={`status-icon ${statusClass}`} />
            <Typography className={`variance-value ${statusClass}`}>
                {isPositive ? '+' : '-'}{displayVal}
            </Typography>
        </>
    );
};

// Helper function for Reconciliation
export const formatAmountForAPI = (value: string): string => {
    if (value === '' || isNaN(Number(value))) return '0.00';
    return parseFloat(value).toFixed(2);
};
